export enum SignalEdge {
  RISING_EDGE = 'RISING_EDGE',
  FALLING_EDGE = 'FALLING_EDGE',
  BOTH = 'BOTH',
}
